import type { PlansFaq } from '../../../lumpsum/plans-list/footer/PlansFaqsSection'

export const SIP_PLANS_FAQS: PlansFaq[] = [
  {
    title: 'What is my SIP Plan?',
    description:
      'Your SIP Plan shows which SIPs to start, stop, increase or decrease, along with the recommended monthly amount in each fund. These changes help your future investments move your portfolio closer to its ideal allocation.'
  },
  {
    title: 'Why is my SIP allocation different from my lump sum allocation?',
    description:
      'Both work towards the same investment strategy. Your lump sum plan recommends changes to your existing investments, while your SIP Plan directs future monthly investments towards gaps in your portfolio. A category that is currently underweight may therefore receive a larger share of your SIPs.'
  },
  {
    title: 'Why am I being asked to start or increase a SIP?',
    description:
      'Starting or increasing a SIP directs more of your monthly investments towards the funds and categories recommended in your strategy. This can help build an allocation that is currently below its ideal level or redirect investments towards a recommended fund.'
  },
  {
    title: 'Why should I stop or reduce a SIP in a fund that is performing well?',
    description:
      'Your SIP Plan considers your overall portfolio allocation as well as fund selection. Even if a fund is performing well, its category may already have enough allocation. Reducing future investments in it can help direct money towards categories that need more allocation.'
  },
  {
    title: 'Does stopping a SIP mean selling my existing investment?',
    description:
      'No. Stopping a SIP stops future instalments; it does not sell the amount you have already invested. Any recommendation to sell your existing holdings is shown separately in your Allocation Plan.'
  },
  {
    title: 'Will these changes increase my total monthly SIP amount?',
    description:
      'Increasing one SIP does not necessarily mean increasing your total monthly investment. It may be balanced by reducing or stopping another SIP. Look at the recommended amounts across all funds together to understand your monthly commitment.'
  },
  {
    title: 'How long will SIPs take to bring my portfolio closer to its ideal allocation?',
    description:
      'This happens gradually as your monthly instalments are invested. The pace depends on your current allocation, portfolio value, SIP amount and market movements. Your SIP Plan helps close allocation gaps over time.'
  },
  {
    title: 'If I follow my SIP Plan, do I still need to follow my Allocation Plan?',
    description:
      'The two plans work together. Your SIP Plan guides future monthly investments, while your Allocation Plan recommends changes to money already invested. Updating your SIPs does not automatically complete the recommended changes to your existing holdings.'
  },
  {
    title: 'Will my SIP Plan change over time?',
    description:
      'Yes. Your recommended SIPs may change when your plan is reviewed, based on your portfolio allocation, monthly investment amount, preferences and fund recommendations. Refer to your latest SIP Plan when making changes.'
  },
  {
    title: 'What does the monthly amount shown against each fund mean?',
    description:
      'It is the recommended total monthly SIP amount for that fund, not an amount to add to your existing SIP. For example, if you currently invest ₹3,000 and the ideal amount is ₹5,000, your SIP Plan would recommend increasing it by ₹2,000.'
  },
  {
    title: 'Why are some of my existing SIP funds missing from my Ideal SIP Plan?',
    description:
      'Your recommended monthly investments may be directed towards other funds or categories that better fit your plan. A fund’s absence from this view does not, by itself, mean you should sell your existing investment.'
  },
  {
    title: 'Should I have a SIP in every fund in my Ideal Portfolio?',
    description:
      'Not necessarily. Your Ideal Portfolio includes the investments you should hold, while your Ideal SIP Plan shows where future monthly investments should go. Some funds may already have sufficient allocation and may not need additional investment through SIPs.'
  },
  {
    title: 'Why is a ‘Sell later’ fund in my Ideal Portfolio but not in my Ideal SIP Plan?',
    description:
      'Your existing investment may be retained because selling it is being deferred due to short-term capital gains (STCG) tax or an ELSS lock-in. This does not automatically mean you should continue adding money to it. Your Ideal SIP Plan can direct future investments towards other recommended funds.'
  }
]
